import React, {Component} from 'react';
import {FormattedHTMLMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import { FLOW_TYPE, CREDIT_TYPE, REDIRECT_SUFFIX } from '../../../framework/App/AppConstants';

const LOCALE_PREFIX = 'US/pages/DecisionPage/IncentiveInfo';
export const INCENTIVE_SUCCESSFULLY_CREATED = 'SUCCESSFULLY_CREATED';

export class IncentiveInfo extends Component {
    static propTypes = {
        incentivesDetails: PropTypes.object,
        creditIncentiveOutcome: PropTypes.string,
        isBAWithoutPurchase: PropTypes.bool,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE))
    };

    render() {
        const { creditIncentiveOutcome, flow, incentivesDetails, isBAWithoutPurchase } = this.props;
        const incentiveCreated = (creditIncentiveOutcome === INCENTIVE_SUCCESSFULLY_CREATED);
        const isDAFlow = (flow === FLOW_TYPE.DIRECT_APP);

        if (creditIncentiveOutcome && incentivesDetails) {
            let messageId = creditIncentiveOutcome;
            if (incentiveCreated && isBAWithoutPurchase) {
                messageId = 'SUCCESS_BA_NO_PURCHASE';
            }
            if (incentiveCreated && isDAFlow) {
                messageId = 'SUCCESS_INCENTIVE_DA';
            }

            return (
                <div id="incentiveInfo" className="incentive-info">
                    <div id={creditIncentiveOutcome}>
                        <p>
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.${messageId}`}
                                values={{incentive_offer_value: incentivesDetails.incentive_offer_value || ''}}
                            />
                        </p>
                    </div>
                </div>
            );
        } else {
            return null;
        }

    }
}

export default injectIntl(IncentiveInfo);
